
import React from "react";
import DOMPurify from "dompurify";

/**
 * SafeHtml - renders sanitized HTML safely using DOMPurify.
 *
 * Props:
 *   html       {string}  - The raw HTML string to sanitize and render.
 *   tag        {string}  - The wrapper element tag (default: "div").
 *   className  {string}  - Optional className for the wrapper element.
 *   style      {object}  - Optional inline styles for the wrapper element.
 *   [rest]               - Any other valid HTML attributes are forwarded.
 */
const SafeHtml = ({ html, tag: Tag = "div", className, style, ...rest }) => {
  return (
    <Tag
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html ?? "") }}
      {...rest}
    />
  );
};

export default SafeHtml;
